import {Stack, Text} from '@mantine/core';
import React, {Dispatch} from 'react';

import {ImportInstrumentDataModalAction} from 'instruments/instrument-data/importInstrumentDataModalReducer';
import {ImportInstrumentDataModalState} from 'instruments/instrument-data/InstrumentDataConstants';
import InstrumentLoginPage from 'instruments/instrument-data/InstrumentLoginPage';

interface OnDemandLoginSectionProps {
  connectionId: string;
  state: ImportInstrumentDataModalState;
  dispatch: Dispatch<ImportInstrumentDataModalAction>;
}

/**
 * Asks for the user's own instrument software login before retrieving data from a connection that requires
 * per-user login. A successful login sets `state.loginUsername`.
 */
export default function OnDemandLoginSection({
  connectionId,
  state,
  dispatch,
}: OnDemandLoginSectionProps): JSX.Element {
  return (
    <Stack spacing="xs">
      <Text size="sm" color="dimmed">
        This connection requires you to log in with your own account to retrieve data.
      </Text>
      <InstrumentLoginPage
        connectionId={connectionId}
        dispatch={dispatch}
        state={state}
        useValidateCredentials={true}
      />
    </Stack>
  );
}
